// Misc Mutations

export const setBaseUrls = (state, payload) => {
  state.baseUrls = payload
}

export const setDisplayGreeting = (state, payload) => {
  state.displayGreeting = payload
}
